var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVitamins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Vitamins_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Vitamins_svg__a",
    d: "M8 4l1.3-1.625A1 1 0 0110.081 2h3.839a1 1 0 01.781.375L16 4v1a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM9.667 9.333L8 11l-1-1M13 10h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Vitamins_svg__a",
    d: "M9 20H6a2 2 0 01-2-2V6a2 2 0 012-2h2M16 4h2a2 2 0 012 2v2M18.262 15.167h-1.167V14a2 2 0 012-2h1.167v1.167a2 2 0 01-2 2zM17 22a3.953 3.953 0 01-4-3.905M13 18.095c0-1.7.8-2.929 2.4-2.929M17 22a3.953 3.953 0 004-3.905M21 18.095c0-1.7-.8-2.929-2.4-2.929M18.6 15.167a11.949 11.949 0 00-1.6.25 11.949 11.949 0 00-1.6-.25M7 15h3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgVitamins;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Vitamins.svg
// module id = 826
// module chunks = 101